import React, { useState } from "react";
import { createPortal } from 'react-dom';

import { Link, useLocation } from "react-router-dom";
import { addSearchParam } from "./Helpers";
import { usePortal } from "./core/Hooks";

import { trackClick } from "./modules/TrackingLink";
import GlossaryModal from "./GlossaryModal";
import Button from "./modules/Button";

const ModalPortal = ({active, onDismiss}) => {
  const target = usePortal("modal");
  return createPortal(
  <GlossaryModal active={active} onDismiss={ onDismiss }/>,
  target);
}

const AboutLink = ({ children }) => {
  const [active, setActive] = useState(false);
  const onClick = () => {
    setActive(true);
    trackClick("open_glossary");
  }

  return (
    <>
    <a className="navigation-link about-link" onClick={ onClick } >
      What is this project?
    </a>
    <ModalPortal active={ active } onDismiss={ () => setActive(false) }/>
    </>
  );
};

export default AboutLink;
